import React, { useRef, useState } from 'react';
import { ArrowCircleLeft2, ArrowDown2, Minus } from 'iconsax-react';
import { ReactComponent as UploadIcon } from '../../Assets/Icons/uploadIcon.svg';
import { useNavigate } from 'react-router-dom';

function AddProperty() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [error, setError] = useState('');
  const fileInputRef = useRef<any>(null); // Use ref to reference the hidden input

  const handleFileChange = (e: any) => {
    const selectedFile = e.target.files[0];
    console.log(file);
    const fileSizeLimit = 10 * 1024 * 1024; // 10MB in bytes

    if (selectedFile.size > fileSizeLimit) {
      setError('File too large. Maximum size is 10MB.');
      setFile(null);
    } else {
      setError('');
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };


  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  return (
    <>
      <div className={'py-9 w-11/12 mx-auto'}>
        <div>
          <ArrowCircleLeft2 size={40} color={'#20996B'} variant={'Bold'} onClick={() => navigate(-1)} />
        </div>
        <h1 className={'font-bold py-5'}>
                    Add Property
        </h1>
        <div className={'p-6 bg-white flex flex-col gap-y-7'}>
          <div className={''} style={{ boxShadow: '0px 1px 2px 0px #38414A26' }}>
            <div className={'border-b border-custom px-4 py-5'}>
              <p>
                                Property Gallery
              </p>
            </div>
            <div>
              <div className={'px-4 py-5'}>
                <h1>Property Image</h1>
                <p className={'text-sm text-custom'}>Add property main image</p>
                <div className={'flex justify-center py-10'}>
                  <div className={' rounded relative'}>
                    <svg width="203" height="205" viewBox="0 0 203 205" fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink">
                      <rect x="0.251953" width="202.107" height="205"
                        fill="url(#pattern0_3192_15968)"/>
                      <defs>
                        <pattern id="pattern0_3192_15968"
                          patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlinkHref="#image0_3192_15968"
                            transform="matrix(0.00494787 0 0 0.00487805 -0.143223 0)"/>
                        </pattern>
                        <image id="image0_3192_15968" width="260" height="205"
                          xlinkHref="data:image/png;base64,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"/>
                      </defs>
                    </svg>
                  </div>
                </div>

                <div>
                  <h1>Property Image</h1>
                  <p className={'text-sm text-custom pb-5'}>Add property main image</p>
                  <div className={'flex flex-col items-center justify-center w-full border-2 h-60 rounded border-dashed border-custom'}>
                    <div className={'flex-col flex items-center justify-center'}>
                      <svg width="62" height="55" viewBox="0 0 62 55" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M25.3155 24.3477L35.0744 34.1043L31.8199 37.3588L27.6155 33.1544V45.9999H23.0155V33.1498L18.8111 37.3588L15.5566 34.1043L25.3155 24.3477ZM25.3159 5.17772e-08C33.4906 0.000387196 40.3678 6.126 41.3101 14.2462C47.2164 15.8569 51.1218 21.4659 50.5829 27.5641C50.0439 33.6623 45.2155 38.4995 39.1182 39.0494L39.1159 34.5C39.1233 26.9735 33.0991 20.8295 25.5743 20.6885C18.0496 20.5476 11.7995 26.4619 11.5251 33.9829L11.5159 34.5V39.0494C5.41838 38.5003 0.589164 33.6635 0.0496734 27.5651C-0.489817 21.4667 3.41528 15.8572 9.32172 14.2462C10.263 6.12549 17.1408 -0.000650306 25.3159 5.17772e-08H25.3159Z"
                          fill="#878A99"/>
                      </svg>
                      <p>Drop files here or click to upload.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className={'flex bg-[#4051890D] items-center py-2 justify-between px-4'}>
              <p>property overview</p>
              <Minus size={15} className={'#000000'} />
            </div>
            <div className={'border border-custom flex justify-between gap-y-7 gap-3.5 px-4 py-5 flex-wrap'}>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                                    Country
                </label>
                <input type={'text'}
                  className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm capitalize'}>
                                    State
                </label>
                <input type={'text'}
                  className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                                    Landmark
                </label>
                <input type={'text'}
                  className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                                    Property Address
                </label>
                <input type={'text'}
                  className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                                    Property Name
                </label>
                <input type={'text'}
                  className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                                    Property Type
                </label>
                <div className="relative">
                  <select
                      className="appearance-none py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full pr-10">
                    <option value="" disabled selected>hhsjs</option>
                    <option>add property features</option>
                    <option>Option 2</option>
                    <option>Option 3</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
                    <ArrowDown2
                        size="20"
                        color="#CED4DA"
                        variant="Bold"
                    />
                  </div>
                </div>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                  No of Slot
                </label>
                <input type={'number'}
                       className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-[24%]'}>
                <label className={'pb-1 block text-sm'}>
                  Slot Price
                </label>
                <input type={'text'}
                       className={' py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'}/>
              </div>
              <div className={'w-full'}>
                <label className={'pb-1 block text-sm'}>
                                    Property Description
                </label>
                <textarea rows={10} className={'py-2 px-4 border border-custom focus-visible:outline-0 rounded w-full'} />
              </div>
            </div>
          </div>

          <div>
            <div className={'flex bg-[#4051890D] items-center py-2.5 justify-between px-4'}>
              <p>Document Upload</p>
              <Minus size={15} className={'#000000'} />
            </div>
            <div className={'border border-custom px-4 py-5'}>
              <div className='pb-5'>
                <div
                  className="flex gap-3.5 justify-between items-center border-dashed border-2 rounded-lg border-custom py-4 px-6">
                  <div className={'flex gap-3.5'}>
                    <UploadIcon/>
                    <div>
                      <p className={'text-custom'}>Upload C of O (Valid)<span
                        className={'text-red-600'}>*</span></p>
                      <p className={'text-gray-400 text-xxs'}>{!fileName ? 'JPG, PNG or PDF, file size no more than 10MB' : fileName}</p>
                    </div>
                  </div>
                  <button onClick={handleButtonClick} type={'button'}
                    className={' uppercase text-custom-lemongreen border border-custom-lemongreen rounded-lg px-4 text-xs py-2.5'}>
                                        Select File
                  </button>
                  <input ref={fileInputRef} name={'upload'} onChange={handleFileChange} required
                    type="file" hidden/>
                </div>
                {error && <p className="text-red-600 text-xs pt-1.5">{error}</p>}
              </div>
              <div className='pb-5'>
                <div
                  className="flex gap-3.5 justify-between items-center border-dashed border-2 rounded-lg border-custom py-4 px-6">
                  <div className={'flex gap-3.5'}>
                    <UploadIcon/>
                    <div>
                      <p className={'text-custom'}>Upload Proof of ownership (Valid)<span
                        className={'text-red-600'}>*</span></p>
                      <p className={'text-gray-400 text-xxs'}>{!fileName ? 'JPG, PNG or PDF, file size no more than 10MB' : fileName}</p>
                    </div>
                  </div>
                  <button onClick={handleButtonClick} type={'button'}
                    className={' uppercase text-custom-lemongreen border border-custom-lemongreen rounded-lg px-4 text-xs py-2.5'}>
                                        Select File
                  </button>
                  <input ref={fileInputRef} name={'upload'} onChange={handleFileChange} required
                    type="file" hidden/>
                </div>
                {error && <p className="text-red-600 text-xs pt-1.5">{error}</p>}
              </div>
              <div className='pb-5'>
                <div
                  className="flex gap-3.5 justify-between items-center border-dashed border-2 rounded-lg border-custom py-4 px-6">
                  <div className={'flex gap-3.5'}>
                    <UploadIcon/>
                    <div>
                      <p className={'text-custom'}>Upload property deed of agreement, (Valid)<span
                        className={'text-red-600'}>*</span></p>
                      <p className={'text-gray-400 text-xxs'}>{!fileName ? 'JPG, PNG or PDF, file size no more than 10MB' : fileName}</p>
                    </div>
                  </div>
                  <button onClick={handleButtonClick} type={'button'}
                    className={' uppercase text-custom-lemongreen border border-custom-lemongreen rounded-lg px-4 text-xs py-2.5'}>
                                        Select File
                  </button>
                  <input ref={fileInputRef} name={'upload'} onChange={handleFileChange} required
                    type="file" hidden/>
                </div>
                {error && <p className="text-red-600 text-xs pt-1.5">{error}</p>}
              </div>
              <div className='pb-5'>
                <div
                  className="flex gap-3.5 justify-between items-center border-dashed border-2 rounded-lg border-custom py-4 px-6">
                  <div className={'flex gap-3.5'}>
                    <UploadIcon/>
                    <div>
                      <p className={'text-custom'}>Upload property survey of agreement, (Valid)<span
                        className={'text-red-600'}>*</span></p>
                      <p className={'text-gray-400 text-xxs'}>{!fileName ? 'JPG, PNG or PDF, file size no more than 10MB' : fileName}</p>
                    </div>
                  </div>
                  <button onClick={handleButtonClick} type={'button'}
                    className={' uppercase text-custom-lemongreen border border-custom-lemongreen rounded-lg px-4 text-xs py-2.5'}>
                                        Select File
                  </button>
                  <input ref={fileInputRef} name={'upload'} onChange={handleFileChange} required
                    type="file" hidden/>
                </div>
                {error && <p className="text-red-600 text-xs pt-1.5">{error}</p>}
              </div>
            </div>
          </div>

          <div className={'flex justify-end w-full gap-3.5'}>
            <button className={'bg-custom-grey text-sm text-white py-2.5 rounded px-6'}>
                            Cancel
            </button>
            <button className={'bg-custom-midnightgreen text-sm text-white py-2.5 rounded px-10'}>
                            Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddProperty;
